export default "__VITE_ASSET__ClfkMqWp__"